import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './SelectOptions.styles';
import MenuItem from '@material-ui/core/MenuItem';
import { Controller } from 'react-hook-form';
import { FormControl, InputLabel } from '@material-ui/core';

const SelectOptions = ({
  options,
  control,
  name,
  width,
  height,
  variant,
  margin,
  padding,
  initialValue,
  disabled,
  label,
  className,
  borderRadius,
  required,
}) => {
  return (
    <Styled.ContainerStyled
      width={width}
      margin={margin}
      borderRadius={borderRadius}
      role="select-container"
      className={className}
    >
      <FormControl variant={variant}>
        {label ? <InputLabel id={name}>{label}</InputLabel> : null}
        <Controller
          name={name}
          control={control}
          defaultValue={initialValue}
          render={({ field }) => (
            <Styled.SelectStyled
              {...field}
              height={height}
              width={width}
              padding={padding}
              disabled={disabled}
              defaultValue={initialValue}
              className={className}
              required={required}
            >
              {options?.map((option) => (
                <MenuItem key={option.ID} value={option.ID}>
                  {option.NOME}
                </MenuItem>
              ))}
            </Styled.SelectStyled>
          )}
        ></Controller>
      </FormControl>
    </Styled.ContainerStyled>
  );
};

export default SelectOptions;

SelectOptions.defaultProps = {
  name: ' ',
  options: [],
  variant: 'standard',
  initialName: null,
  initialValue: null,
  label: '',
  disabled: false,
};

SelectOptions.propTypes = {
  name: PropTypes.string,
  options: PropTypes.array,
  control: PropTypes.any,
  width: PropTypes.string,
  variant: PropTypes.string,
  height: PropTypes.string,
  margin: PropTypes.string,
  padding: PropTypes.string,
  initialName: PropTypes.any,
  initialValue: PropTypes.any,
  required: PropTypes.any,
  label: PropTypes.string,
  disabled: PropTypes.bool,
};
